import { genericFetchingActionCreator, genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

/**
 * 
 * @param {Integer} props.auditId the ID of the current audit
 * @param {Integer} props.correspondenceId null by default, but will not be null if this is called after visibility setting on an audit is changed, and is used for sending to the state the index of the audit changed
 * @returns 
 */
export const getCorrespondenceList = ({auditId, correspondenceId}) => (dispatch, getState) => {
    dispatch(genericFetchingActionCreator('AUDIT_CORRESPONDENCE', 'fetching'))
    fetch(`/lgyhub/api/audits/${auditId}/correspondence`, {
      credentials: 'include',
      method: 'GET'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'fetching this document')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        dispatch(genericFetchingActionCreator('AUDIT_CORRESPONDENCE', 'error'))
        throw new Error(responseJson.errors[0].message)
      } else {
        const state = getState()
        
        if(correspondenceId) {
          dispatch(genericFetchingActionCreator('AUDIT_CORRESPONDENCE', 'fetched', { list: responseJson, changedIndex:  state.oversight?.correspondence?.list?.findIndex(doc => doc.id === correspondenceId)}))
        } else {
          dispatch(genericFetchingActionCreator('AUDIT_CORRESPONDENCE', 'fetched', { list: responseJson }))
        }
      }
    }).catch((error) => {
      console.error('Audit search fetching error: ', error)
    })
  }

export const updateVisibilityStatus = (visibility, auditId, correspondenceId) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('AUDIT_CORRESPONDENCE', 'posting'))
    fetch(`/lgyhub/api/audits/${auditId}/correspondence/${correspondenceId}?visibility=${visibility}`, {
      credentials: 'include',
      method: 'PATCH',
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'updating the visibility status for this document')
    }).then((responseJson) => {
      if (responseJson.status >= 400) {
        throw new Error(responseJson.errors[0].message)
      } else {
        dispatch(genericPostingActionCreator('AUDIT_CORRESPONDENCE', 'posted', responseJson))
        dispatch(getCorrespondenceList({auditId, correspondenceId}))
      }
    }).catch((error) => {
      dispatch(genericPostingActionCreator('AUDIT_CORRESPONDENCE', 'error'))
      console.error('Audit edit failed: ', error)
    })
  }
}